if (!customElements.get('logo-slider')) {
  class LogoSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.swiper = new Swiper(this.querySelector('.js-slider'), {
        navigation: {
          prevEl: this.querySelector('.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-button-next'),
        },
        draggable: true,
        variableWidth: true,
        slidesPerView: 3,
        loop: true,
        breakpoints: {
          990: {
            slidesPerView: 4,
          },
          1024: {
            slidesPerView: 6,
          }
        }
      });
    }
  }
  customElements.define('logo-slider', LogoSlider);
}
